import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=35ef0e8c&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=35ef0e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef0e8c",
  null
  
)

export default component.exports